module.exports = __webpack_public_path__ + "static/media/WDIGFC App_images_stethoscope_992x896.8d5d29c8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/WDIGFC App_images_stethoscope_992x896.jpg
// module id = 848
// module chunks = 0